import { render } from "./WorkAddressForm.vue?vue&type=template&id=e5261a42&ts=true&lang=pug"
import script from "./WorkAddressForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./WorkAddressForm.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/WorkAddressForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e5261a42"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e5261a42', __exports__)) {
    console.log('reload')
    api.reload('e5261a42', __exports__)
  }
  
  module.hot.accept("./WorkAddressForm.vue?vue&type=template&id=e5261a42&ts=true&lang=pug", () => {
    console.log('re-render')
    api.rerender('e5261a42', render)
  })

}


export default __exports__